<template></template>
<script>
import { userCountryCode } from "@/mixins/userCountryCode";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "Analytics",
  props: ["screener", "currentFilmIndex", "currentTime", "filmId"],
  data() {
    return {
      country_code: this.DEFINES.DEFAULT_COUNTRY_CODE,
      sessionId: this.$store.state.auth.key,
      totalWatchSeconds: null,
      videoAnalyticsIntervalId: null,
      analyticsInterval: 10000,
      eventAnalyticsIntervalId: null,
      isVideoEnded : null
    };
  },

  mounted() {
    this.getCountryCode();
    this.updateEventAnalyticsInterval("start");
  },

  computed: {
    ...mapGetters("consumer", {
      profile: "getConsumer"
    }),
    ...mapGetters("auth", {
      isPreviewMode: "isPreviewMode"
    })
  },

  mixins: [userCountryCode],

  beforeDestroy() {
    this.updateEventAnalyticsInterval("clear");
  },

  methods: {
    async getCountryCode() {
      this.country_code = await this.getUserCountryCode();
    },

    async updateEventAnalyticsInterval(type) {
      if (type == "start") {
        this.eventAnalyticsIntervalId = setInterval(
          this.pushEventAnalytics,
          this.analyticsInterval
        );
      } else {
        clearInterval(this.eventAnalyticsIntervalId);
        this.eventAnalyticsIntervalId = null;
      }
    },

    setIntervalIfNeeded(video, currentTime) {
      if (
        this.videoAnalyticsIntervalId == null &&
        video.playing
      ) {
        this.totalWatchSeconds = video.currentTime;
        this.videoAnalyticsIntervalId = setInterval(
          this.pushVideoAnalytics,
          this.analyticsInterval,
          video
        );
      }
    },

    clearIntervalWhenDone(video) {
      if (this.videoAnalyticsIntervalId) {
        clearInterval(this.videoAnalyticsIntervalId);
        this.videoAnalyticsIntervalId = null;
        this.isVideoEnded = true;
        this.pushVideoAnalytics(video);
      }
    },

    checkIsScreenerOver() {
      if (this.isPreviewMode) {
        return;
      }

      if (this.screener) {
        let screenerTotalEndTime = this.moment
          .utc(this.screener.screening_starts_at)
          .add(this.screener.screening_tolerance, "minutes")
          .local()
          .format();

        let currentTime = this.moment().local().format();
        if (currentTime > screenerTotalEndTime) {
          this.$store.dispatch("app/showMessage", {
            message: this.$t('screener/event_is_ended'),
            color: "error",
          });
          this.$router.push({ name: "user.dashboard" });
        }
      }
    },

    async pushEventAnalytics() {
      this.checkIsScreenerOver();

      await axios
        .post(this.DEFINES.CLOUD_ANALYTICS_URL, {
          entityId: this.screener.id,
          entityType: "event",
          userId: this.profile.id,
          watchSeconds: this.analyticsInterval/1000,
          playLength: 0,
          sessionId: this.sessionId,
          key: this.DEFINES.CLOUD_ANALYTICS_KEY,
          countryCode: this.country_code,
          frequency: this.analyticsInterval,
          device: navigator.userAgent,
          env:this.DEFINES.NODE_ENV
        })
        .catch(error => {
          //catch axios errors
          if (error.response != undefined) {
            console.log(error.response);
          } else {
            throw error;
          }
        });
    },

    async pushVideoAnalytics(video) {
      // IMP : case when video has been played upto the end
      // and user refreshes the page then video cursor is at end but still
      // video ended and timeupdate event
      // triggers again and add an addition entry of full video duration
      // if (video.ended && this.totalWatchSeconds === null) {
      //   return;
      // }

      // if video is paused but not ended then do nothing
      //  if (video.paused && !video.ended) {
      //   return;
      // }
      if (!video.playing && this.isVideoEnded !== true) {
        return;
      }

      // if totalWatchSeconds is greated than currentTime then
      // it means that time has already been covered
      // or its a backward
      if (this.totalWatchSeconds > video.currentTime) {
        return;
      }

      // watchSeconds should be equal to interval but
      // if the diff between currentTime of this request
      // and totalWatchSeconds of prev request is less than
      // interval then we should consider that - in case of ended video
      // or in between backward forward
      var watchSeconds = this.analyticsInterval / 1000;
      var diff = video.currentTime - this.totalWatchSeconds;
      if (diff > 0 && diff < watchSeconds) {
        watchSeconds = diff;
      }

      //update totalWatchSeconds for upcoming requests
      this.totalWatchSeconds += watchSeconds;
      await axios
        .post(this.DEFINES.CLOUD_ANALYTICS_URL, {
          entityId: this.filmId ?this.filmId :this.screener.film_ids[this.currentFilmIndex],
          entityType: "video",
          userId: this.profile.id,
          watchSeconds: watchSeconds,
          playLength: video.currentTime,
          sessionId: this.sessionId,
          key: this.DEFINES.CLOUD_ANALYTICS_KEY,
          countryCode: this.country_code,
          frequency: this.analyticsInterval,
          device: navigator.userAgent,
          env:this.DEFINES.NODE_ENV
        })
        .catch(error => {
          //catch axios errors
          if (error.response != undefined) {
            console.log(error.response);
          } else {
            throw error;
          }
        });
      // console.log("added tracking");
      if (this.isVideoEnded === true) {
        this.totalWatchSeconds = null;
        this.isVideoEnded = false;
      }
    }
  }
};
</script>
